import Carousel from '@picsart/carousel/Carousel';
import { ReactNode } from 'react';

interface ITextureCarouselProps {
    children: ReactNode;
}

const TextureCarousel = ({ children }: ITextureCarouselProps) => (
  <Carousel hideArrows hidePagination isMultiSlide>
    {children}
  </Carousel>
);

export default TextureCarousel;
